// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"ba7aff33","811":"e39c5ec9"}[chunkId] + ".chunk.js";
};